import { InvoiceState, InvoiceType, invoiceStateOptions, invoiceTypeOptions } from 'types';
import { createSelectField, Option } from './createSelectField';

export const InvoiceStateSelectField = createSelectField<Option<InvoiceState>>(invoiceStateOptions, { simple: true });

export const InvoiceTypeSelectField = createSelectField<Option<InvoiceType>>(invoiceTypeOptions, { simple: true });
